var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/navigationmanager/parts/removenavigationnode',["require", "exports", "common/parts"], function (require, exports, Parts) {
    "use strict";
    var RemoveNavigationNode = (function (_super) {
        __extends(RemoveNavigationNode, _super);
        function RemoveNavigationNode() {
            _super.apply(this, arguments);
        }
        RemoveNavigationNode.prototype.process = function (symbol) {
            try {
                var parent = symbol.parent;
                parent.raw.children.splice(parent.raw.children.indexOf(symbol.raw), 1);
                parent.children.remove(symbol);
                this.output.call({});
            }
            catch (error) {
                this.error.call(error);
            }
        };
        return RemoveNavigationNode;
    }(Parts.Part));
    return RemoveNavigationNode;
});

